<template>
  <div class="mx-0 ml-sm-2 px-0 px-sm-2">
    <div class="mt-2 pt-2" :style="{ width: xs ? '300%' : '100%' }" style="height: calc(100vh - 200px)">
      <v-row v-for="week in 6" :key="week" class="week-row">
        <div v-for="weekDay in 7" :key="weekDay" class="d-flex overflow-hidden calendar-duty-card-wrapper">
          <calendar-duty-card :dutyAndDate="getDuty(week, weekDay)" :selectedDutyId="selectedDutyId" @onDutySelected="onDutySelected"></calendar-duty-card>
        </div>
      </v-row>
    </div>
  </div>
</template>

<script>
import CalendarDutyCard from '@/modules/myDuties/components/CalendarDutyCard.vue';
import index from '@/modules/myDuties';
import { DAY_IN_MS } from '@/common/constants';
import common from '@/mixins/common';
import dateUtils from '@/common/dateUtils';

export default {
  name: 'Dutiesmonthcalendar',
  mixins: [common],
  components: {
    CalendarDutyCard,
  },
  props: {
    dutiesByDate: Object,
    monthDate: Date,
  },
  data() {
    return {
      moduleType: index.moduleType,
      today: Date.now(),
      selectedDutyId: null,
      ready: false,
      // month: this.monthDate.getMonth(),
      // year: this.monthDate.getFullYear(),
      weekday: [1, 2, 3, 4, 5, 6, 0],
      weekDayNames: { 1: 'Mo', 2: 'Di', 3: 'Mi', 4: 'Do', 5: 'Fr', 6: 'Sa', 0: 'So' },
      value: '',
    };
  },
  computed: {
    firsOfCalendarMonth: {
      get() {
        return this.$store.state.meinDienst.firsOfCalendarMonth;
      },
      set(value) {
        this.$store.commit(`meinDienst/setFirsOfCalendarMonth`, value);
      },
    },
  },
  methods: {
    onDutySelected(duty) {
      this.selectedDutyId = duty ? duty.id : null;
      console.debug('selectedDutyId', JSON.stringify(duty, null, 2));

      this.$emit('onDutySelected', duty);
    },
    getDate(weekOfMonth, weekDayNum) {
      let date = new Date(this.firsOfCalendarMonth.getTime() - this.firsOfCalendarMonth.getDay() * DAY_IN_MS);
      return new Date(date.getTime() + ((weekOfMonth - 1) * 7 + weekDayNum) * DAY_IN_MS);
    },
    getDuty(weekOfMonth, weekDayNum) {
      let date = this.getDate(weekOfMonth, weekDayNum);
      return { date, duty: this.dutiesByDate[dateUtils.formatDateAsYYYYMMDD(date)] };
    },
  },
};
</script>
<style scoped>
.week-row > div {
  width: calc(14.28% - 6px);
  height: 9rem;
  font-size: 1.2em;
  text-align: center;
  border-radius: 3px;
  background: var(--v-background-base);

  opacity: 0.85;
  margin: 3px;
}

.title > div {
  width: calc(14.28% - 6px);
  font-size: 0.95rem;
  height: 50px;
  padding: 10px 0;
  text-align: center;
  background: var(--v-secondary-base);
  border: 1px solid var(--v-background-base);
  margin: 3px;
}

.calendar-duty-card-wrapper {
  border-radius: 6px;
  /*border: 1px solid var(--v-background-darken-3);*/
}

/* xs -x-small */
@media (max-width: 599px) {
  .week-row > div {
    font-size: 1em;
  }
}

/* sm - small */
@media (min-width: 600px) and (max-width: 959px) {
}

/* md - medium */
/* e.g. LVB Tablet 980 x  1650 */
@media (min-width: 960px) and (max-width: 1263px) {
}

/* md - medium */
@media (width: 980px) {
}

/* lg - large */
@media (min-width: 1264px) and (max-width: 1904px) {
}

/* xl - extra large */
@media (min-width: 1905px) {
}
</style>
